import { render, staticRenderFns } from "./ModalCopyLink.vue?vue&type=template&id=0fa6d204"
import script from "./ModalCopyLink.vue?vue&type=script&lang=js"
export * from "./ModalCopyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports